import { motion } from "framer-motion";
import { CheckCircle2, Phone } from "lucide-react";
import { SITE } from "@/lib/site";

export const QuoteSuccess = () => (
  <motion.div
    initial={{ opacity: 0, scale: 0.97 }}
    animate={{ opacity: 1, scale: 1 }}
    transition={{ duration: 0.6, ease: [0.22, 1, 0.36, 1] }}
    className="text-center py-6 sm:py-10"
    role="status"
    aria-live="polite"
    data-testid="quote-success"
  >
    <span className="mx-auto grid h-20 w-20 place-items-center rounded-full bg-gradient-to-br from-emerald-500/25 to-emerald-500/5 border border-emerald-400/30 text-emerald-300 shadow-[0_0_60px_-12px_rgba(16,185,129,0.7)]">
      <CheckCircle2 className="h-9 w-9" aria-hidden="true" />
    </span>
    <h3 className="mt-8 text-2xl sm:text-3xl font-semibold text-white">Thanks! Your quote request has been received.</h3>
    <p className="mx-auto mt-4 max-w-lg text-base text-slate-400 leading-relaxed">
      Your project information has been submitted successfully. We'll review your requirements and contact you to discuss your website — and once it's built, we launch your new website and take care of it as well.
    </p>
    <p className="mt-8 text-sm text-slate-500">Call us directly:</p>
    <a href={SITE.phoneHref} className="btn-secondary mt-3" data-testid="quote-success-phone-link">
      <Phone className="h-4 w-4" aria-hidden="true" /> {SITE.phone}
    </a>
    <p className="mt-8 text-xs text-slate-600">{SITE.name} · ABN {SITE.abn}</p>
  </motion.div>
);
